module.exports = __webpack_public_path__ + "images/external_images/svg/icons/024-maintenance.svg";